const isClientEnv = process.env.WEBPACK === 'build.client' || process.env.WEBPACK === 'dev'


export default isClientEnv
